module.exports = __webpack_public_path__ + "img/fire_truck.7c6f35b6.png";